import moment from 'moment-timezone';

import { WeekDayNumber } from './utils';

export interface UpdateLocalesOptions {
  isTimeFormat24: boolean;
  weekStartDay?: WeekDayNumber;
}

function getTimePattern(isTimeFormat24: boolean, withSeconds: boolean = false) {
  const pattern = isTimeFormat24 ? 'H:mm' : 'h:mm a';
  return withSeconds ? pattern.replace('mm', 'mm:ss') : pattern;
}

function update(locale: string, options: UpdateLocalesOptions) {
  moment.updateLocale(locale, {
    meridiem: hours => (hours > 11 ? 'PM' : 'AM'),
    week: {
      dow: options.weekStartDay === 0 ? 0 : 1,
    },
    longDateFormat: {
      LT: getTimePattern(options.isTimeFormat24),
      LTS: getTimePattern(options.isTimeFormat24, true),
      L: 'MM-DD-YYYY',
      l: 'M-D-YYYY',
      LL: 'Do MMMM YYYY',
      ll: 'D MMM YYYY',
      LLL: 'Do MMMM YYYY LT',
      lll: 'D MMM YYYY LT',
      LLLL: 'dddd, Do MMMM YYYY LT',
      llll: 'ddd, D MMM YYYY LT',
    },
  });
}

function unifyLangCodeISO(locale: string): string {
  switch (locale) {
    case 'no':
      // https://en.wikipedia.org/wiki/ISO_639:nb
      return 'nb';
    default:
      return locale;
  }
}

export function momentUpdateLocales(locale: string, options: UpdateLocalesOptions) {
  update(unifyLangCodeISO(locale), options);
}
